import { create } from "zustand";

export type AssociateMessageFilters = {
  lifecycle?: {
    category: string;
    values: string[];
  };
};

export type AssociateMessagePayload = {
  moduleId?: string;
  filters?: AssociateMessageFilters;
};

type ProcessMessageStore = {
  associateMessageData?: AssociateMessagePayload;
  setProcessMessage: (params: AssociateMessagePayload) => void;
};

export const useProcessMessageStore = create<ProcessMessageStore>((set) => ({
  associateMessageData: undefined,
  setProcessMessage(data) {
    set(() => ({
      associateMessageData: {
        moduleId: data.moduleId,
        filters: data.filters,
      },
    }));
  },
}));

